/** Split free text into trimmed email candidates (commas, whitespace, newlines). */
export const tokenizeEmails = (text: string): string[] =>
  text
    .split(/[,\s]+/)
    .map((email) => email.trim())
    .filter(Boolean);
